import { createContext, useContext } from 'react';
import type { FinancialPOAIntake } from '@bedside-docs/contracts';

export type FinancialPoaFormContextValue = {
  intake: FinancialPOAIntake | null;
};

export const FinancialPoaFormContext =
  createContext<FinancialPoaFormContextValue | null>(null);

export const useFinancialPoaFormContext = () =>
  useContext(FinancialPoaFormContext);
